function getWishlistButtonSelector()
{
  return ".wishlist-btn, [data-wishlist-button]";
}

const wishlistObserver = new MutationObserver(function(mutations)
{
  let found = false;

  mutations.forEach(mutation =>
  {
    mutation.addedNodes.forEach(node =>
    {
      if (
        node.nodeType === 1 &&
        (
          node.classList?.contains("wishlist-btn") ||
          node.hasAttribute?.("data-wishlist-button") ||
          node.querySelector?.(getWishlistButtonSelector())
        )
      )
      {
        found = true;
      }
    });
  });

  if (found)
  {
    markWishlistButtons();
  }
});

wishlistObserver.observe(document.body, {
  childList: true,
  subtree: true
});


function getWishlistProducts()
{
  if (!window.WISHLIST || typeof window.WISHLIST.products !== "object")
    return {};

  return window.WISHLIST.products;
}


function markWishlistButtons()
{
  const products = getWishlistProducts();

  document.querySelectorAll(getWishlistButtonSelector()).forEach(button =>
  {
    const handle = button.dataset.productHandle;

    if (!handle) return;

    if (products[handle])
      button.classList.add("active");
    else
      button.classList.remove("active");
  });
}

function changeWishlistCount(delta)
{
  const counters = document.querySelectorAll(".wishlist-count");

  counters.forEach(counter =>
  {
    let count = parseInt(counter.textContent) || 0;

    count += delta;

    if (count < 0) count = 0;

    counter.textContent = count;
  });
}

document.addEventListener("click", function (e)
{
  const button = e.target.closest(getWishlistButtonSelector());

  if (!button) return;

  e.preventDefault();

  const handle = button.dataset.productHandle;

  if (!handle) return;

  if (!window.WISHLIST || !window.WISHLIST.customerId)
  {
    showLoginDialog();
    return;
  }

  toggleWishlist(handle, button);
});


async function toggleWishlist(handle, button)
{
  if (button.disabled) return;

  button.disabled = true;

  let products = { ...getWishlistProducts() };

  const exists = !!products[handle];

  if (exists)
  {
    delete products[handle];
    button.classList.remove("active");
        changeWishlistCount(-1); 

  }
  else
  {
    products[handle] = {
      added_at: new Date().toISOString()
    };

    button.classList.add("active");
    changeWishlistCount(+1);
  }

  window.WISHLIST.products = products;

  await updateWishlistMetafield(products);

  button.disabled = false;
}



function isInWishlist(handle)
{
  const products = getWishlistProducts();

  return !!products[handle];
}


async function updateWishlistMetafield(products)
{
  try
  {
    const response = await fetch(
      "https://wishlist-api.viveksaikhom.workers.dev",
      {
        method: "POST",

        headers:
        {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({
          customerId: window.WISHLIST.customerId,
          products: Object.keys(products)
        })
      }
    );

    const data = await response.json();

    if (data && data.products)
    {
      window.WISHLIST.products = data.products;

      markWishlistButtons();
    }
  }
  catch (err)
  {
    console.error("Wishlist update failed", err);
  }
}


function showLoginDialog()
{
  if (document.getElementById("wishlist-login-popup"))
    return;

  if (!document.getElementById("wishlist-login-style"))
  {
    const style = document.createElement("style");
    style.id = "wishlist-login-style";

    style.textContent = `
.bottom-csign {
  display:flex;
  border-top:1px solid gray;
  margin:20px 0 0;
  align-items:center;
  justify-content:space-around;
}

.wishlist-loader {
  width:64px;
  height:44px;
  position:relative;
  border:5px solid #fff;
  border-radius:8px;
}

.wishlist-loader::before {
  content:'';
  position:absolute;
  border:5px solid #fff;
  width:32px;
  height:28px;
  border-radius:50% 50% 0 0;
  left:50%;
  top:0;
  transform:translate(-50%, -100%);
}

.wishlist-loader::after {
  content:'';
  position:absolute;
  transform:translate(-50%, -50%);
  left:50%;
  top:50%;
  width:8px;
  height:8px;
  border-radius:50%;
  background-color:#fff;
  box-shadow:16px 0 #fff, -16px 0 #fff;
  animation:wishlist-flash 0.5s ease-out infinite alternate;
}

@keyframes wishlist-flash {
  0% {
    background-color:rgba(255,255,255,0.25);
    box-shadow:16px 0 rgba(255,255,255,0.25),
               -16px 0 rgba(255,255,255,1);
  }
  50% {
    background-color:rgba(255,255,255,1);
    box-shadow:16px 0 rgba(255,255,255,0.25),
               -16px 0 rgba(255,255,255,0.25);
  }
  100% {
    background-color:rgba(255,255,255,0.25);
    box-shadow:16px 0 rgba(255,255,255,1),
               -16px 0 rgba(255,255,255,0.25);
  }
}
`;

    document.head.appendChild(style);
  }

  const html = `
  <div id="wishlist-login-popup"
       style="
         position:fixed;
         inset:0;
         display:flex;
         justify-content:center;
         align-items:center;
         z-index:9999;

         backdrop-filter:blur(8px);
         -webkit-backdrop-filter:blur(8px);

         background:rgba(0,0,0,0.2);
       ">

    <div id="wishlist-dialog-box"
         style="
           position:relative;
           background:#000;
           min-width:320px;
           min-height:130px;
           text-align:center;
           color:white;
           font-size:14px;
           text-transform:uppercase;
           font-family:'GT America Price';
           border-radius:6px;
           overflow:hidden;
         ">

      <div id="wishlist-dialog-content">

        <div style="padding:25px 20px 0;">
          <h3 style="margin:0;">Please login to use wishlist</h3>
        </div>

        <div class="bottom-csign">

          <a id="wishlist-login-btn"
             href="${window.STOREFRONT_LOGIN_URL}"
             style="
               flex:1;
               padding:18px;
               color:white;
               text-decoration:none;
               cursor:pointer;
             ">
            Login
          </a>

          <button id="wishlist-close-btn"
            style="
              flex:1;
              padding:18px;
              background:none;
              border:none;
              border-left:1px solid rgba(255,255,255,0.2);
              color:white;
              cursor:pointer;
            ">
            Close
          </button>

        </div>

      </div>

      <div id="wishlist-login-loading"
           style="
             display:none;
             position:absolute;
             inset:0;
             justify-content:center;
             align-items:center;
             flex-direction:column;
             gap:15px;
           ">

        <div class="wishlist-loader"></div>

        <div style="font-size:12px;opacity:0.7;">
          Redirecting...
        </div>

        <button id="wishlist-cancel-login"
          style="
            background:none;
            border:1px solid rgba(255,255,255,0.4);
            color:white;
            padding:6px 18px;
            cursor:pointer;
          ">
          Cancel
        </button>

      </div>

    </div>

  </div>
  `;

  document.body.insertAdjacentHTML("beforeend", html);

  const popup = document.getElementById("wishlist-login-popup");
const loginBtn = document.getElementById("wishlist-login-btn");
const closeBtn = document.getElementById("wishlist-close-btn");
const cancelBtn = document.getElementById("wishlist-cancel-login");
const loading = document.getElementById("wishlist-login-loading");
const content = document.getElementById("wishlist-dialog-content");
const dialogContainer = document.getElementById("wishlist-dialog-box");

closeBtn.onclick = () => popup.remove();

cancelBtn.onclick = () => popup.remove();

loginBtn.onclick = function(e)
{
  e.preventDefault();

  dialogContainer.style.minHeight = "180px";
  dialogContainer.style.background = "rgba(0,0,0,0)";

  content.style.opacity = "0";
  content.style.display = "none";

  loading.style.display = "flex";

  if (typeof storeReturnUrl === "function")
    storeReturnUrl();

  setTimeout(() =>
  {
    window.location.href = loginBtn.href;
  }, 80);
};

}
